import React, { useState } from 'react';
import { loginUser } from '../../Hanlder/AuthenticationHandler.js';
import '../SignUp/Auth.css';
// import sankalvaxLogo from '../../assets/sankalvax-logo.png'; 
// ← Adjust this path if your logo lives elsewhere

const Login = ({ onLogin, onToggleToSignup }) => {
  // ————————— LOGIN STATE —————————
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');

  const handleLogin = async (e) => {
    e.preventDefault();
    try {
      const user = await loginUser(email, password);
      console.log("userrr",user)
      localStorage.setItem('user', JSON.stringify(user));
      localStorage.setItem('isLoggedIn', 'true');
      onLogin(user);
    } catch (err) {
      setError('Invalid email or password');
    }
  };

  // —————— ANIMATED “WELCOME…” SETUP ——————
  const welcomeText = "Welcome to Sankalvax Nexus";

  return (
    <div className="auth-box">
      {/*
        1) The white banner at the top: contains the logo + animated letters.
           We build each <span> with class="char" (or char-space if it's a space),
           and assign an inline animationDelay so letters appear one after another.
           The entire sequence then fades out & restarts infinitely.
      */}
      <div className="welcome-banner">
        <img src="images/skx_logo.png" alt="Sankalvax Logo" className="welcome-logo" />
        <h1 className="welcome-text">
          {welcomeText.split("").map((char, idx) => {
            const isSpace = char === " ";
            return (
              <span
                key={idx}
                className={isSpace ? "char char-space" : "char"}
                style={{ animationDelay: `${idx * 0.12}s` }}
              >
                {char}
              </span>
            );
          })}
        </h1>
      </div>

      {/*
        2) The UNCHANGED “Login” heading + form below.
      */}
      <h2>Login</h2>

      <form onSubmit={handleLogin} className="auth-form">
        {error && <p className="error-text">{error}</p>}

        <input
          className="input"
          type="email"
          placeholder="Email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          required
        />

        <input
          className="input"
          type="password"
          placeholder="Password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          required
        />

        <button type="submit" className="submitbutton">
          Log In
        </button>
      </form>

      <div className="bottom-text">
        Don't have an account?{' '}
        <span className="signup-link" onClick={onToggleToSignup}>
          Sign Up
        </span>
      </div>
    </div>
  );
};

export default Login;
